import AutoLayout from "../../../../../AutoLayout/AutoLayout";
import ColorfulBrandText from "../ColorfulBrandText/ColorfulBrandText";
import FontText from "../../../../../../FontText/FontText";
import React from "react";
import {
  AutoLayoutAlignEnum,
  AutoLayoutDirectionEnum,
} from "../../../../../AutoLayout/AutoLayoutEnums";
import { FontSizeEnum, FontTypeEnum } from "../../../../../../FontText/FontTextEnums";
import { ThemeColorEnum } from "../../../../../../Themes/ThemeEnums";

interface AppNameProps {
  appName: string;
  fontSize: FontSizeEnum;
}

const AppName: React.FC<AppNameProps> = ({ appName, fontSize }) => {
  return (
    <AutoLayout $direction={AutoLayoutDirectionEnum.HORIZONTAL} $align={AutoLayoutAlignEnum.LEFT}>
      {appName && (
        <FontText
          text={appName}
          $color={ThemeColorEnum.ON_SURFACE_VARIANT}
          $fontType={FontTypeEnum.TITLE}
          $fontSize={fontSize}
        />
      )}

      <ColorfulBrandText fontSize={fontSize} />
    </AutoLayout>
  );
};

export default AppName;
